/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const login = /* GraphQL */ `
  query Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      statusCode
      body
    }
  }
`;
export const authorize = /* GraphQL */ `
  query Authorize($sessionId: String!) {
    authorize(sessionId: $sessionId) {
      statusCode
      body
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($sessionId: String!) {
    getUser(sessionId: $sessionId) {
      statusCode
      body
    }
  }
`;
export const getPdfResult = /* GraphQL */ `
  query GetPdfResult($sessionId: String!, $bucket: String!, $key: String!) {
    getPdfResult(sessionId: $sessionId, bucket: $bucket, key: $key) {
      statusCode
      body
    }
  }
`;
export const deactivateDoctor = /* GraphQL */ `
  query DeactivateDoctor($oktaId: String!) {
    deactivateDoctor(oktaId: $oktaId) {
      statusCode
      body
    }
  }
`;
export const orderRequisition = /* GraphQL */ `
  query OrderRequisition($sessionId: String!, $doctorRequisitionId: String!) {
    orderRequisition(
      sessionId: $sessionId
      doctorRequisitionId: $doctorRequisitionId
    ) {
      statusCode
      body
    }
  }
`;
export const createDoctorRequisition = /* GraphQL */ `
  query CreateDoctorRequisition(
    $oktaId: String!
    $status: RequisitionStatus!
    $firstName: String!
    $lastName: String!
    $email: String!
    $testTypeId: String!
    $sessionId: String!
    $requisitionNumber: String
    $sendPurchaseLink: Boolean!
  ) {
    createDoctorRequisition(
      oktaId: $oktaId
      status: $status
      firstName: $firstName
      lastName: $lastName
      email: $email
      testTypeId: $testTypeId
      sessionId: $sessionId
      requisitionNumber: $requisitionNumber
      sendPurchaseLink: $sendPurchaseLink
    ) {
      statusCode
      body
    }
  }
`;
export const createDoctor = /* GraphQL */ `
  query CreateDoctor($oktaId: String!, $sessionId: String!) {
    createDoctor(oktaId: $oktaId, sessionId: $sessionId) {
      statusCode
      body
    }
  }
`;
export const createDoctorLicense = /* GraphQL */ `
  query CreateDoctorLicense(
    $oktaId: String!
    $sessionId: String!
    $licenses: String!
  ) {
    createDoctorLicense(
      oktaId: $oktaId
      sessionId: $sessionId
      licenses: $licenses
    ) {
      statusCode
      body
    }
  }
`;
export const createDoctorNote = /* GraphQL */ `
  query CreateDoctorNote(
    $sessionId: String!
    $doctorId: String!
    $doctorPatientTestId: String!
    $note: String!
  ) {
    createDoctorNote(
      sessionId: $sessionId
      doctorId: $doctorId
      doctorPatientTestId: $doctorPatientTestId
      note: $note
    ) {
      statusCode
      body
    }
  }
`;
export const readDoctorRequisition = /* GraphQL */ `
  query ReadDoctorRequisition(
    $oktaId: String!
    $sessionId: String!
    $status: RequisitionStatus
    $requisitionId: String
    $patientLastName: String
    $barcode: String
    $lastKey: LastEvaluatedKeyRequisition
    $queryOrder: QueryOrder
  ) {
    readDoctorRequisition(
      oktaId: $oktaId
      sessionId: $sessionId
      status: $status
      requisitionId: $requisitionId
      patientLastName: $patientLastName
      barcode: $barcode
      lastKey: $lastKey
      queryOrder: $queryOrder
    ) {
      statusCode
      body
    }
  }
`;
export const readDoctor = /* GraphQL */ `
  query ReadDoctor($oktaId: String!, $sessionId: String!) {
    readDoctor(oktaId: $oktaId, sessionId: $sessionId) {
      statusCode
      body
    }
  }
`;
export const readDoctorLicense = /* GraphQL */ `
  query ReadDoctorLicense($doctorId: String!, $sessionId: String!) {
    readDoctorLicense(doctorId: $doctorId, sessionId: $sessionId) {
      statusCode
      body
    }
  }
`;
export const readDoctorTestTypes = /* GraphQL */ `
  query ReadDoctorTestTypes($sessionId: String!, $oktaId: String!) {
    readDoctorTestTypes(sessionId: $sessionId, oktaId: $oktaId) {
      statusCode
      body
    }
  }
`;
export const readDoctorNote = /* GraphQL */ `
  query ReadDoctorNote($sessionId: String!, $doctorPatientTestId: String!) {
    readDoctorNote(
      sessionId: $sessionId
      doctorPatientTestId: $doctorPatientTestId
    ) {
      statusCode
      body
    }
  }
`;
export const updateDoctorRequisition = /* GraphQL */ `
  query UpdateDoctorRequisition(
    $sessionId: String!
    $doctorRequisitionId: String!
    $status: RequisitionStatus!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $testTypeId: String
    $address: String
    $approvedAt: String
    $approvedResultsAt: String
  ) {
    updateDoctorRequisition(
      sessionId: $sessionId
      doctorRequisitionId: $doctorRequisitionId
      status: $status
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      testTypeId: $testTypeId
      address: $address
      approvedAt: $approvedAt
      approvedResultsAt: $approvedResultsAt
    ) {
      statusCode
      body
    }
  }
`;
export const updateDoctor = /* GraphQL */ `
  query UpdateDoctor(
    $sessionId: String!
    $oktaId: String!
    $address: String
    $firstName: String
    $lastName: String
    $phone: String
  ) {
    updateDoctor(
      sessionId: $sessionId
      oktaId: $oktaId
      address: $address
      firstName: $firstName
      lastName: $lastName
      phone: $phone
    ) {
      statusCode
      body
    }
  }
`;
export const verifyIdentityIntercom = /* GraphQL */ `
  query VerifyIdentityIntercom($email: String!) {
    verifyIdentityIntercom(email: $email) {
      statusCode
      body
    }
  }
`;
export const listConsultations = /* GraphQL */ `
  query ListConsultations($sessionId: String!, $doctorRequisitionId: String!) {
    listConsultations(
      sessionId: $sessionId
      doctorRequisitionId: $doctorRequisitionId
    ) {
      statusCode
      body
    }
  }
`;
export const listAllConsultations = /* GraphQL */ `
  query ListAllConsultations(
    $sessionId: String!
    $doctorId: String!
    $status: ConsultStatus!
  ) {
    listAllConsultations(
      sessionId: $sessionId
      doctorId: $doctorId
      status: $status
    ) {
      statusCode
      body
    }
  }
`;
export const getPatientRequisitions = /* GraphQL */ `
  query GetPatientRequisitions(
    $oktaId: String!
    $sessionId: String!
    $patientEmail: String
    $lastKey: LastEvaluatedKeyRequisition
    $queryOrder: QueryOrder
  ) {
    getPatientRequisitions(
      oktaId: $oktaId
      sessionId: $sessionId
      patientEmail: $patientEmail
      lastKey: $lastKey
      queryOrder: $queryOrder
    ) {
      statusCode
      body
    }
  }
`;
export const getRequisitionsByStatus = /* GraphQL */ `
  query GetRequisitionsByStatus(
    $oktaId: String!
    $sessionId: String!
    $status: RequisitionStatus
    $lastKey: LastEvaluatedKeyRequisition
    $queryOrder: QueryOrder
  ) {
    getRequisitionsByStatus(
      oktaId: $oktaId
      sessionId: $sessionId
      status: $status
      lastKey: $lastKey
      queryOrder: $queryOrder
    ) {
      statusCode
      body
    }
  }
`;
